import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LogTask } from '../model/LogTask';
import { TaskStatus } from '../model/TaskStatus';
import { AuthenticationService } from './authentication.service';


export class LogTaskResponse {
  count: number;
  tasks: LogTask[];
  downloadURL: string;
}

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  private apiURL: string;
  private baseURL: string

  constructor(private http: HttpClient, private authService: AuthenticationService) {
    this.apiURL = "/services/otsc-server/v1/managers";
    this.baseURL = this.apiURL + "/support/";
  }

  getLogTasks(pageSize: number, startIndex: number): Observable<HttpResponse<LogTaskResponse>> {
    let url = this.baseURL + "logs";
    return this.http.get<LogTaskResponse>(url,
      {
        observe: 'response',
        params:{
          pageSize: pageSize.toString(),
          startIndex: startIndex.toString()
        }
      });
  }

  packageLogs(env: number, name: string, manager: boolean, agents: string[], sysreport: boolean,
    includeLandscape: boolean, logTaskIds: string[], agent: boolean, showNotification: boolean): Observable<HttpResponse<TaskStatus>> {
    let url = this.baseURL + "logs";
    let body = new URLSearchParams();
    body.set('name', name);
    body.set('env', env.toString());
    body.set('manager', manager.toString());
    body.set('agent', agent.toString());
    body.set('sysreport', sysreport.toString());
    body.set('includeLandscape', includeLandscape.toString());
    body.set('showNotification', showNotification.toString());

    agents.forEach((agent: string) => {
      body.append('agents[]', agent);
    });

    logTaskIds.forEach((logTaskId: string) => {
      body.append('logTaskIds[]', logTaskId);
    });

    return this.http.post<TaskStatus>(url, body.toString(),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        }),
        observe: 'response'
      });
  }

  deleteTasks(ids: string[], env: number): any {
    let url = this.baseURL + "logs";
    let body = new URLSearchParams();

    body.set('env', env.toString());

    ids.forEach((id: string) => {
      body.append('uids[]', id);
    });

    return this.http.request<boolean>('DELETE', `${url}`, {
      body: body.toString(),
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      observe: 'response'
    });
  }

  getManagerDiskSpace(): Observable<HttpResponse<any>> {
    let url = this.baseURL + "manager/disk";
    return this.http.get<any>(url,
      {
        observe: 'response',
      });
  }

  listDirectoryContent(path:string): Observable<HttpResponse<any>> {
    let url = this.baseURL + "SFTP";
    return this.http.get<any>(url,
      {
        observe: 'response',
        params:{
          path: path
        }
      });
  }

  uploadToSFTP(path:string, logsPackageId:string): Observable<any> {

    const url = this.baseURL + "SFTP";
    const body = new URLSearchParams();
    body.set('path', path);
    body.set('logsPackageId', logsPackageId);
    
    return this.http.post(url, body.toString(), {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'text/event-stream',
      }),
      observe: 'events',
      responseType: 'text',
      reportProgress: true
    });
  }

  cancelUploadingToSFTP(path:string, logsPackageId:string): Observable<any> {
    const url = this.baseURL + "SFTP";
    const body = new URLSearchParams();
    body.set('path', path);
    body.set('logsPackageId', logsPackageId);
    
    return this.http.request<boolean>('DELETE', `${url}`, {
      body: body.toString(),
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      observe: 'response'
    });
  }
  
  getLogsPackageFileName(logsPackageId:string): Observable<HttpResponse<any>> {
    let url = this.baseURL + "logsPackageFileName";
    return this.http.get<LogTaskResponse>(url,
      {
        observe: 'response',
        params:{
          logsPackageId: logsPackageId
        }
      });
  }
}
